import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { Platform } from "react-native";
import { GlobalThisABTestClient } from "../../domain/globalThisABTestClient/GlobalThisABTestClient";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";
import { OS } from "../shared/config";

const globalThisABTestClient = new GlobalThisABTestClient();

const useShowDeliveryAndReturnProductPage = () => {
  const {
    session: { auth },
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const { isLoading, data } = useQuery(
    {
      queryKey: ["useShowDeliveryAndReturnProductPage"],
      queryFn: async () => {
        if (Platform.OS !== OS.WEB) {
          return false;
        }

        const experiments = await globalThisABTestClient.getExperiments();
        return Boolean(experiments?.showDeliveryAndReturnProductPage);
      },
      enabled: Boolean(auth),
    },
    queryClient,
  );

  return { showDeliveryAndReturnProductPage: Boolean(data), isLoading };
};

export { useShowDeliveryAndReturnProductPage };
